import { Listing, OfferType } from '@smg-real-estate/hg-rets-schema';

import {
  EventAction,
  EventLabel,
  GTMPageFeatureId,
  InteractionContainerDetail,
  InteractionContainerName,
  InteractionEvent,
  InteractionGoal,
  TargetPageTitle,
} from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized, trackEventWithoutPreDefinedListing } from '@/helpers/GTM/GTMTrack';

export function trackExpandMobiliarHouseholdInsuranceWidget(): void {
  const dataObj = {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: InteractionGoal.OPEN_DETAILS,
    h_event_label_008: InteractionContainerName.HOUSEHOLD_INSURANCE_MOBILIAR,
  };

  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, dataObj);
}

export function trackPartnerLink(
  externalUrl: string,
  interactionGoal: InteractionGoal,
  listingId?: string | null,
): void {
  trackEventHarmonized(InteractionEvent.PARTNER_LINK, {
    h_event_category_006: InteractionEvent.PARTNER_LINK,
    h_event_action_007: interactionGoal,
    h_event_label_008: `pdp-content_${listingId ?? '__MISSING_ID__'}`,
    h_target_url_029: externalUrl,
  });
}

export function trackTenantPlusCrifCTAClick(): void {
  trackEventHarmonized(InteractionEvent.CTA_CLICK, {
    h_event_category_006: InteractionEvent.CTA_CLICK,
    h_event_action_007: EventAction.GO_TO_TENANT_PLUS,
    h_event_label_008: EventLabel.TENANTPLUS_TRIAL_CRIF_FROM_PDP_BOTTOMSHEET,
  });
}

export function trackBottomSheetCtaClick(
  listing: Listing,
  bottomSheetType: InteractionGoal,
  ctaTitle: TargetPageTitle,
  externalUrl: string,
): void {
  trackEventHarmonized(InteractionEvent.PARTNER_LINK, {
    h_event_category_006: InteractionEvent.PARTNER_LINK,
    h_event_action_007: bottomSheetType,
    h_event_label_008: `pdp-bottomSheet_${listing.id}`,
    h_target_page_title_026: ctaTitle,
    h_target_url_029: externalUrl,
    h_listing_advertisement_id_120: listing.id ?? '__MISSING_ID__',
    h_listing_price_gross_303:
      listing.offerType === OfferType.Rent
        ? listing.prices?.rent?.gross
        : listing.prices?.buy?.price,
  });
}

export function trackPartnerTooltip(
  goal: InteractionGoal,
  containerName?: InteractionContainerName,
  containerDetail?: InteractionContainerDetail,
): void {
  trackEventWithoutPreDefinedListing(InteractionEvent.PDP_INTERACTION, {
    h_web_feature_id_019: GTMPageFeatureId.PDP_INTERACTION,
    interaction_containerDetail: containerDetail,
    interaction_containerName: containerName,
    interaction_goal: goal,
  });
}

export function trackRentalCertificateModalClick(externalUrl: string, listingId: string): void {
  trackEventHarmonized(InteractionEvent.PARTNER_LINK, {
    h_event_category_006: InteractionEvent.PARTNER_LINK,
    h_event_action_007: InteractionGoal.RENTAL_PROVISIONAL_CERT,
    h_event_label_008: `pdp-bottomSheet_${listingId}`,
    h_target_url_029: externalUrl,
  });
}

export function trackSunriseISPWidgetDisplayed(): void {
  trackEventHarmonized(InteractionEvent.FEATURE_DISPLAYED, {
    h_event_category_006: InteractionEvent.FEATURE_DISPLAYED,
    h_event_action_007: InteractionGoal.PARTNER_INTEGRATION,
    h_event_label_008: InteractionContainerName.SUNRISE,
  });
}

export function trackExpandSunriseISPWidget(): void {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_action_007: InteractionGoal.OPEN_DETAILS,
    h_event_label_008: InteractionContainerName.SUNRISE,
  });
}

export function trackSunriseISPWidgetLearnMoreClick(targetUrl: string): void {
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_action_007: InteractionGoal.LEARN_MORE,
    h_event_label_008: InteractionContainerName.SUNRISE,
    h_target_url_029: targetUrl,
  });
}
